import { Checkbox } from "antd";
import useAdBlockStore from "store/AdBlockStore";
import { LabelledSelect, LabelledInput } from "../Fields";
import { INIT_OFFER_TEXT } from "config";
import useKeypress from "react-use-keypress";


export const OfferBuilder = ({ offerTypes }) => {
  const currentOffer = useAdBlockStore((state) => state.currentOffer);
  const updateCurrentOffer = useAdBlockStore((state) => state.updateCurrentOffer);
  const setActiveField = useAdBlockStore((state) => state.setActiveField);
  const products = useAdBlockStore((state) => state.products);
  const focusPreviousField = useAdBlockStore((state) => state.focusPreviousField);
  const focusNextField = useAdBlockStore((state) => state.focusNextField);

  useKeypress(['Tab'], (event) => {
    if (event.shiftKey) {
      focusPreviousField("offer-builder", event);
      return;
    }
    focusNextField("offer-builder", event);
  });

  useKeypress(['/'], (event) => {
    if (event.altKey || event.metaKey) {
      event.preventDefault();
      const offerTextField = document.querySelector('#offer-type-select');
      if (offerTextField) {
        offerTextField.focus();
      }
    }
  });

  return (
    <span id="offer-builder" className="offer-builder">
      <LabelledSelect type={"inline"} variant="filled"
        label="Offer Type" placeholder="Select Offer Type"
        id="offer-type-select"
        options={
          offerTypes.map(item => ({
            label: item.title,
            value: item.id,
          }))
        }
        value={currentOffer?.offer_type || ""}
        onFocus={() => setActiveField("offer_type")}
        onChange={(value) => {
          if (value) {
            setTimeout(() => {
              updateCurrentOffer({
                offer_text: INIT_OFFER_TEXT[value.toLowerCase()],
                offer_type: value
              })
              focusNextField("offer-builder");
            }, 300)
          }
        }}
      />
      <LabelledInput label="Offer Text" placeholder="Offer Text" allowclear="true"
        value={currentOffer?.offer_text || ""}
        onFocus={() => {
          useAdBlockStore.setState({ leftPanelView: "offer_text" });
          setActiveField("offer_text");
        }}
        onChange={(val) => {
          updateCurrentOffer({ offer_text: val?.replace(/\,/g, "") })// prevent comma(,)
        }}
      />
      <div className="d-flex justify-content-between align-items-center" style={{ width: '100%' }}>
        <div style={{ width: '32%' }}        >
          <LabelledInput label="Reg. Price Start" placeholder="Reg. Price Start"
            allowclear="true" inputType="float"
            value={currentOffer?.reg_price || ""}
            onChange={(val) => updateCurrentOffer({ reg_price: val })}
            onFocus={() => setActiveField("reg_price")}
          />
        </div>
        <div style={{ width: '32%' }}        >
          <LabelledInput label="Reg. Price End" placeholder="Reg. Price End"
            allowclear="true" inputType="float"
            value={currentOffer?.reg_price2_d || ""}
            onChange={(val) => updateCurrentOffer({ reg_price2_d: val })}
            onFocus={() => setActiveField("reg_price2_d")}
          />
        </div>
        <div style={{ width: '33%' }}        >
          <LabelledInput label="Limit" placeholder="Limit"
            allowclear="true" inputType="float"
            value={currentOffer?.limit || ""}
            onChange={(val) => updateCurrentOffer({ limit: val })}
            onFocus={() => setActiveField("limit")}
          />
        </div>
      </div>
      <div className="d-flex justify-content-between align-items-center" style={{ width: '100%' }}>
        <div style={{ width: '69%' }}        >
          <LabelledInput label="Minimum Qualifier" placeholder="Minimum Qualifier"
            allowclear="true" inputType="float"
            value={currentOffer?.min_qty || ""}
            onChange={(val) => updateCurrentOffer({ min_qty: val })}
            onFocus={() => setActiveField("min_qty")}
          />
        </div>
        <div style={{ width: '29%' }} className="mt-3">
          <LabelledSelect variant="filled" allowClear label=""
            options={[
              { value: true, label: 'Dollars' },
              { value: false, label: 'Quantity' }
            ]}
            value={currentOffer?.min_qty_dollar_f}
            onFocus={() => setActiveField("min_qty_dollar_f")}
            onChange={(value) => {
              updateCurrentOffer({ min_qty_dollar_f: value })
              setTimeout(() => focusNextField("offer-builder"), 0);
            }}
          />
        </div>
      </div>
      <Checkbox checked={currentOffer?.must_buy_f}
        onChange={(e) => updateCurrentOffer({ must_buy_f: e.target.checked })}
        onFocus={() => setActiveField("none")} >
        Does the offer have must buy amounts?
      </Checkbox>
      <Checkbox checked={currentOffer?.mix_and_match_f}
        onChange={(e) => updateCurrentOffer({ mix_and_match_f: e.target.checked })}
        onFocus={() => setActiveField("none")} >
        Does the offer allow mix and match?
      </Checkbox>
      <Checkbox checked={currentOffer?.include_in_net_cost_f}
        onChange={(e) => updateCurrentOffer({ include_in_net_cost_f: e.target.checked })}
        onFocus={() => setActiveField("none")} >
        Does the offer include net cost?
      </Checkbox>
      <Checkbox
        disabled={(products.find(p => p.liner_f)) ? false : true}
        checked={currentOffer?.liner_f}
        onChange={(e) => updateCurrentOffer({ liner_f: e.target.checked })}
        onFocus={() => setActiveField("none")} >
        Does the offer have a liner?
      </Checkbox>
    </span>
  )
}